import { useLocation } from '@/queries/locations';
import { FunctionComponent, ReactElement, useMemo } from 'react';
import LocationFilter from './LocationFilter';
import { RootLevelFilterProps } from './RootLevelFilter';

interface LevelFilterProps extends RootLevelFilterProps {
	parentId?: string;
}

const LevelFilter: FunctionComponent<LevelFilterProps> = ({
	level,
	parentId,
	selectedLocation,
	setLocation,
}): ReactElement => {
	const { query } = useLocation({ locationId: parentId });
	const { data: location, isFetching, isFetchingNextPage, fetchNextPage } = query;
	const { pages } = location || {};

	const locations = useMemo(() => pages?.flatMap((page) => page.subLocations.data), [pages]);

	return (
		<LocationFilter
			level={level}
			locations={locations}
			selectedLocation={selectedLocation}
			setLocation={setLocation}
			disabled={(isFetching && !isFetchingNextPage) || !parentId}
			isLoadingOptions={isFetching && !isFetchingNextPage}
			isLoadingMoreOptions={isFetchingNextPage}
			/* eslint-disable @typescript-eslint/no-misused-promises */
			loadMoreOptions={fetchNextPage}
		/>
	);
};

export default LevelFilter;
